'use strict';

const isTabletDevice = () => {
    const userAgent = (navigator.userAgent || navigator.vendor || window.opera);
    return /Android|webOS|iPad|BlackBerry/i.test(userAgent);
};

module.exports = isTabletDevice;
